function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0002 3.2002C8.9314 3.2002 3.2002 8.9314 3.2002 16.0002C3.2002 23.069 8.9314 28.8002 16.0002 28.8002C23.069 28.8002 28.8002 23.069 28.8002 16.0002C28.8002 8.9314 23.069 3.2002 16.0002 3.2002ZM21.021 19.5127C21.4381 19.9298 21.4381 20.6039 21.021 21.021C20.813 21.229 20.5399 21.3335 20.2669 21.3335C19.9938 21.3335 19.7207 21.229 19.5127 21.021L16.0002 17.5085L12.4877 21.021C12.2797 21.229 12.0066 21.3335 11.7335 21.3335C11.4605 21.3335 11.1874 21.229 10.9794 21.021C10.5623 20.6039 10.5623 19.9298 10.9794 19.5127L14.4919 16.0002L10.9794 12.4877C10.5623 12.0706 10.5623 11.3965 10.9794 10.9794C11.3965 10.5623 12.0706 10.5623 12.4877 10.9794L16.0002 14.4919L19.5127 10.9794C19.9298 10.5623 20.6039 10.5623 21.021 10.9794C21.4381 11.3965 21.4381 12.0706 21.021 12.4877L17.5085 16.0002L21.021 19.5127Z",
  fill: "currentColor"
}));

function SvgIconCloseRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    className: "injected-svg js-injected-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRounded);
export default __webpack_public_path__ + "static/media/icon-close-rounded.db4d9f5f.svg";
export { ForwardRef as ReactComponent };